import { useMutation } from '@apollo/client';
import React from 'react';
import ModalFormComp from '../../../components/ModalFormComp';
import useToast from '../../../customHooks/useToast';
import { APPROVE_LOAN_PENDING_AUTHORIZATION } from '../../../graphql/admin_mutations';
import ActivateMerchantIcon from '../../../svgs/ActivateMerchantIcon';

interface IApproveLoanModal{
  closeModal?:any;
  loanId?:string;
  handlegetAllCaLoans?:any;
}
const ApproveLoanModal = ({
  closeModal, loanId, handlegetAllCaLoans,
}:IApproveLoanModal) => {
  const Toast = useToast();
  const [approve, { loading: approveLoading }] = useMutation<
  { approveLoanPendingAuthorization: any },
  any
>(APPROVE_LOAN_PENDING_AUTHORIZATION);

  const handleConfirmActivation = async () => {
    if (!approveLoading) {
      try {
        const res = await approve({
          variables: { id: loanId, approve: true },
        });

        if (
          res?.data?.approveLoanPendingAuthorization
          && res?.data?.approveLoanPendingAuthorization?.status === 200) {
          Toast.success(res?.data?.approveLoanPendingAuthorization?.message || 'Operation successful');
          handlegetAllCaLoans();
          closeModal();
        } else {
          Toast.error(res?.data?.approveLoanPendingAuthorization?.message || 'Operation Failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  return (
    <div>
      <ModalFormComp confirmationBtnContent={approveLoading ? 'Approving...' : 'Approve'} closeModal={closeModal} removeTitle modalType="admin-confirmation-modal" confirmActionBtn={handleConfirmActivation} btnLoading={approveLoading} confirmationIcon={<ActivateMerchantIcon />} confirmationSubTitle="Are you sure you want to approve this loan?" confirmationTitle="Approve loan" />

    </div>
  );
};
export default ApproveLoanModal;
